import type { ApolloClient } from '@apollo/client'
import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'
import { ImputableProjectSelectorDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { createAsyncFilterWithQuery } from './createAsyncFilterWithQuery'

export const createProjectAsyncFilter = (apolloClient: ApolloClient<unknown>): FilterDefinition =>
  createAsyncFilterWithQuery({
    label: i18n.t('expenses_v2.forms.fields.projects.project'),
    apolloClient,
    query: ImputableProjectSelectorDocument,
    variables: {
      onlyActive: false,
      assigned: false,
    },
    mapData: (data) => {
      const edges = data?.projectManagement?.imputableProjectsConnection?.edges || []
      const projects = edges.map((edge) => edge.node)
      return projects.map((project) => ({
        label: project.code
          ? `${project.code} - ${project.name}`
          : project.name || `Project ${project.id}`,
        value: project.id,
      }))
    },
  })
